import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BusComponent from "../../../BusComponent";

import Checkbox from '../../../form/Checkbox';
import Slider from '../../../form/Slider';

class OpacitySlider extends BusComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            dataOpacity: props.mapInstance.satelliteDataOverlayDataOpacity * 100,
            hasColor: !!props.mapInstance.satelliteDataOverlaySatelliteHasColor,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            dataOpacity: nextProps.mapInstance.satelliteDataOverlayDataOpacity * 100,
            hasColor: !!nextProps.mapInstance.satelliteDataOverlaySatelliteHasColor,
        });
    }

    onDataOpacityChanged = dataOpacity => {
        this.setState({ dataOpacity }, () => {
            this.emit('SET_SATELLITE_DATA_OVERLAY_DATA_OPACITY_REQUEST', {
                mapInstanceId: this.props.mapInstance.id,
                opacity: dataOpacity / 100,
            });
        });
    }

    onColorChanged = hasColor => {
        this.setState({ hasColor }, () => {
            this.emit('TOGGLE_SATELLITE_DATA_OVERLAY_SATELLITE_COLOR_REQUEST', {
                mapInstanceId: this.props.mapInstance.id,
            });
        });
    }

    render() {
        const { dataOpacity, hasColor } = this.state;

        return (
            <div className='satellite-legend-details'>
                <div className="flex-it column">
                    <div className="satellite-legend-details__data-opacity">
                        <span>
                            {this.props.intl.formatMessage({ id: 'dataBrowser.dataOpacity' })}
                        </span>
                        <div className="flex-it space-between center row margin-top-12 margin-left-12">
                            <Slider
                                className="grow"
                                min={0}
                                max={100}
                                step={10}
                                value={dataOpacity}
                                onChange={this.onDataOpacityChanged}
                            />
                            <span className="satellite-legend-details__data-opacity-label">{dataOpacity}%</span>
                        </div>
                    </div>
                    <div className="satellite-legend-details__color">
                        <div className="dark-secondary-text">
                            {this.props.intl.formatMessage({ id: 'dataBrowser.satelliteColor' })}
                        </div>
                        <Checkbox
                            checked={hasColor}
                            onCheck={this.onColorChanged}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

OpacitySlider.propTypes = {
    mapInstance: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(OpacitySlider);
